export const SIGN_UP_FALLBACK = 'Register'
export const LOG_IN_FALLBACK = 'Log in'
export const WELCOME_FALLBACK = 'Welcome back'
export const DESCRIPTION = {
  studentbeans: {
    fallback: 'Log in to your Student Beans account'
  },
  gradbeans: {
    fallback:
      'Log in to your Student Beans or Grad Beans account to verify your graduation status'
  },
  beansId: {
    fallback:
      'Log in to Beans iD to access discounts on all of your favourite brands'
  }
}
